module.exports = __webpack_public_path__ + "static/media/the-future-of-food-on-a-tiny-island-nation-desktop.80da2b16.jpg";